module.exports = __webpack_public_path__ + "static/media/arrow_right_btn.d290d3b4.svg";